import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Location, UserType, User } from '../../models/user.model';
import { environment } from '../../../environments/environment';
import { ReportMetadata, ReportCategory, ReportYear,ReportState, FrequencyType, ReportAutoPublishPolicy, ReportType, ReportDistributionType} from '../../models/report.model';

@Injectable()
export class LookupService {

  // endpoint = 'http://localhost:58830/api/Lookup/';

  endpoint = environment.apiEndpoint + '/Lookup/';

  constructor(private http: HttpClient) { }

  getUserTypes(): Observable<any> {
    return this.http.get(this.endpoint + 'GetUserTypes');
  }

  getAppRoles(): Observable<any> {
    return this.http.get(this.endpoint + 'GetAppRoles');
  }

  getAppRolesByUserTypeId(userTypeId: number): Observable<any> {
    return this.http.get(this.endpoint + 'GetAppRolesByUserTypeId?userTypeId=' + userTypeId);
  }

  getRootLocations(userType: string): Observable<any> {
    return this.http.get(this.endpoint + 'GetRootLocations?userType=' + userType);
    //  return this.http.post(this.endpoint + 'GetRootLocations', userType);
  }

  getChildLocations(parentId: Number): Observable<any> {
     return this.http.get(this.endpoint + 'GetChildLocations?parentLocationId=' + parentId);
  }

  getLocation(locationId: Number): Observable<any> {
    return this.http.get(this.endpoint + 'GetLocation?locationId=' + locationId);
  }

  getParentLocation(locationId: Number): Observable<any> {
    return this.http.get(this.endpoint + 'GetParentLocation?locationId=' + locationId);
 }

  getLocationHierarchy(locationId: number): Observable<any> {
    return this.http.get(this.endpoint + 'GetLocationHierarchy?locationId=' + locationId);
  }

 getReportCategoryById(id: number): Observable<any> {
    return this.http.get(this.endpoint + 'GetReportCategory?id=' + id);
  }

  getUserLocations(): Observable<any> {
    //return this.http.get('http://localhost:58830/api/User/GetUserLocations');
    return this.http.get(environment.apiEndpoint + '/User/GetUserLocations');
  }

  getUserCategories(): Observable<any> {
    //return this.http.get('http://localhost:58830/api/User/GetUserLocations');
    return this.http.get(environment.apiEndpoint + '/User/GetUserCategories');
  }
 
  getUserAllReportCategories(): Observable<any> {
    //return this.http.get('http://localhost:58830/api/User/GetUserLocations');
    return this.http.get(environment.apiEndpoint + '/User/GetUserReportCategories');
  }

  getPostApprovers(postId: number): Observable<any> {
    return this.http.get(this.endpoint + 'GetPostApprovers?postLocationId=' + postId);
  }

  GetReportCategories(locationId: number):Observable<any>{
    console.log("From Service "+ locationId);
    return this.http.get(this.endpoint + 'GetReportCategories?programAreaId=' + locationId)
  }
  getAllReportCategories$ ():Observable<ReportCategory[]>{
    return this.http.get(this.endpoint+'GetReportCategories').map((reportCategories:ReportCategory[])=>reportCategories);
  }
  
  
  getReportYear():Observable<any>{
    return this.http.get(this.endpoint + 'GetReportYears');
  }

  getAllActiveUsers$():Observable<User[]>{
    return this.http.get(environment.apiEndpoint + '/User/GetAllActiveUsers').map((usersList:User[])=>usersList);
  }

  getPendingHqUsers$(): Observable<User[]>{
    return this.http.get<User[]>(environment.apiEndpoint + '/User/GetPendingHqUsers');
  }

  getAllDeActiveUsers$(): Observable<User[]>{
    return this.http.get<User[]>(environment.apiEndpoint + '/User/GetAllDeActiveUsers').map((usersList:User[])=>usersList);;
  }

  getAllRegions$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllRegions').map((regionList:Location[])=>regionList);
  }
  getAllCountries$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllCountries').map((countryList:Location[])=>countryList);
  }
  getAllPosts$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllPosts').map((postList:Location[])=>postList);
  }

  getAllProgramAreas$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllProgramAreas').map((programAreaList:Location[])=>programAreaList);
  }

  getAllDivisions$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllDivisions').map((divisionList:Location[])=>divisionList);
  }

  getAllActiveProgramAreas$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllActiveProgramAreas').map((programAreaList:Location[])=>programAreaList);
  }
  getAllActiveReportAutoPublishPolicies$():Observable<ReportAutoPublishPolicy[]>{
    return this.http.get(this.endpoint + 'GetAllActiveReportAutoPublishPolicies').map((autoPublishPolicyList:ReportAutoPublishPolicy[])=>autoPublishPolicyList);
  }
  getAllActiveReportCategories$():Observable<ReportCategory[]>{
    return this.http.get(this.endpoint + 'GetAllActiveReportCategories').map((reportCategories:ReportCategory[])=>reportCategories);
  }
  
  getReportCategoryHierarchy$(includeAll:boolean=true):Observable<any>{
    return this.http.get(this.endpoint + 'GetReportCategoryHierarchy?includeAll='+includeAll);
  }

  getReportStates$():Observable<ReportState[]>{
    return this.http.get(this.endpoint+'GetReportStates').map((reportStatesList:ReportState[])=>reportStatesList);
  }
  getFrequencyTypes$():Observable<FrequencyType[]>{
    return this.http.get(this.endpoint+'GetFrequencyTypes').map((frequencyTypes:FrequencyType[])=>frequencyTypes);
  }

  getAllReportTypes$():Observable<ReportType[]>{
    return this.http.get(this.endpoint+'GetAllReportTypes').map((reportTypesList:ReportType[])=>reportTypesList);
  }

  getAllReportDistributionTypes$():Observable<ReportDistributionType[]>{
    return this.http.get(this.endpoint+'GetAllReportDistributionTypes').map((reportDistributionTypesList:ReportDistributionType[])=>reportDistributionTypesList);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/lookups/lookup.service.ts